<template>
  <NuxtLayout class="NuxtLayout min100vh" :class="{ mounted }">
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
// import Stats from "stats.js"; // Import Stats
// let stats: Stats;
// if (import.meta.client) {
//   stats = new Stats();
//   stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
//   stats.dom.classList.add("stats");
//   document.body.appendChild(stats.dom);
//   const updateStats = () => {
//     stats.begin();
//     stats.end();
//     requestAnimationFrame(updateStats);
//   };

//   requestAnimationFrame(updateStats);
// }

import { setWindowSize } from "~/plugins/functions/vhCheck";
const store = useLayoutStore();

const prismic = usePrismic();
const translatesStore = useTranslatesStore();
await useAsyncData("All_Translations", async () => {
  return await translatesStore.GET_All_Translations(false, prismic);
});

const mounted = ref(false);

// get navigation
const getNavigation = async () => {
  const navigation = await prismic.client.getSingle("navigation", {});
  if (navigation?.data?.list) {
    store.SET_Navigation(navigation.data.list);
    return navigation.data.list;
  }
  return null;
};
await useAsyncData("navigation", getNavigation);

const resize = () => {
  setWindowSize();
  store.setDocScreenSize();
};

if (import.meta.client) setWindowSize();
onMounted(() => {
  setWindowSize();
  store.setDocScreenSize();
  window.addEventListener("resize", resize);
  requestAnimationFrame(() => {
    mounted.value = true;
  });
});
onUnmounted(() => window.removeEventListener("resize", resize));
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger); // register ScrollTrigger

const GET_ShowModal = computed(() => store.GET_ShowModal);
if (import.meta.client) {
  document.body.classList.toggle("modal-open", GET_ShowModal.value !== null);
  watch(GET_ShowModal, (value) => {
    document.body.classList.toggle("modal-open", value !== null);
  });
}
</script>
<style lang="scss">
.NuxtLayout:not(.mounted) * {
  transition: none !important;
}
.NuxtLayout {
  display: flex;
  flex-direction: column;
  main {
    flex: 1;
  }
}
.stats {
  transform: scale(1.5);
  transform-origin: top left;
}
</style>
